import ShareForwardIcon from '@/assets/icons/Share-Forward';
import { TelegramIconOutline } from '@/common/icons/TelegramIconOutline';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { CloudDownload, PhoneCall, UserCog2 } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface TActions {
  id: string;
  regnum: string;
  isLoading?: boolean;
}

export const Actions: FC<TActions> = ({ id, regnum, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-5 justify-between w-full">
        {!isLoading ? (
          <div className="flex items-center gap-4">
            <p className="text-lg font-semibold text-green-default">{regnum}</p>
            <div className="flex items-center gap-2">
              <Button variant="ghost" className="p-0">
                <CloudDownload className="stroke-cyan-default" />
              </Button>
              <a
                href={`https://crop2.agro.uz/?land=${id}`}
                target="_blank"
                rel="noopener noreferrer"
                className=" rounded hover:bg-muted transition"
              >
                <ShareForwardIcon />
              </a>
            </div>
          </div>
        ) : (
          <div className="h-9 bg-gray-200 rounded animate-pulse w-32" />
        )}
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              className="!p-0 text-midnight shadow-none hover:bg-transparent"
            >
              <UserCog2 size={18} color="green" />
              {t('connect')}
            </Button>
          </PopoverTrigger>
          <PopoverContent
            className="w-90 -translate-x-4 border-0"
            sideOffset={8}
            alignOffset={-20}
          >
            <div className="grid gap-4">
              <div className="flex flex-col gap-3">
                <h4 className="text-sm font-medium leading-none">
                  Mahmudov Ro'zimboy
                </h4>
                <Link
                  to="tel:+998901234567"
                  className="flex items-center gap-2.5"
                >
                  <PhoneCall size={20} color="#469D18" />
                  +998 90 123 45 67
                </Link>
                <Link
                  to="https://t.me/mahmudov_r"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5"
                >
                  <TelegramIconOutline width={20} height={20} />
                  @mahmudov_r
                </Link>
              </div>
            </div>
          </PopoverContent>
        </Popover>
      </div>

      {/* <div className="flex items-center">
        {show && (
          <>
            <Button
              type="button"
              variant="outline"
              className="ml-5 rounded-[10px] border-green-default"
              onClick={() => setOpen(true)}
            >
              <span>{t('create.project')}</span>
            </Button>

            {isSubmit && (
              <>
                <Button
                  type="button"
                  onClick={() => {
                    setTab('all');
                    form.reset();
                  }}
                  variant="outline"
                  className="ml-2.5 rounded-[10px]"
                >
                  <span>{t('clean')}</span>
                </Button>
                <Button
                  type="button"
                  onClick={onSubmit}
                  variant="secondary"
                  className="ml-2.5 rounded-[10px]"
                  disabled={isLoadingPro}
                >
                  <span>{t('save')}</span>
                </Button>
              </>
            )}
          </>
        )}
      </div> */}
    </div>
  );
};
